<div class="transport-entry" [ngClass]="{'selected' : selected}" matRipple>
  <sc-flex>
    @if (transport.plannedForAssignment) {
      <sc-icon iconClass="fa-chevrons-left" style="color: red;"></sc-icon>
      <sc-content-spacer [half]="true"></sc-content-spacer>
    }
    @if (transport.automaticallyPlanned) {
      <sc-icon iconClass="fa-robot"></sc-icon>
      <sc-content-spacer [half]="true"></sc-content-spacer>
    }
    <app-transport-scope-icon [scope]="transport.transport.scope"></app-transport-scope-icon>
    <div class="title">{{transport.transport.identifyingNumberplate}}</div>
    <sc-content-spacer grow></sc-content-spacer>
    <div class="duration">{{transport.transport.processing.processingTime}}</div>
  </sc-flex>
  <sc-content-spacer vertical [half]="true"></sc-content-spacer>
  <sc-flex>
    <div class="carrier">{{transport.transport.masterdata.carrier}}</div>
  </sc-flex>
  <sc-content-spacer vertical [half]="true"></sc-content-spacer>
  <sc-flex>
    @if (transport?.transport?.timing?.planningDate && !transport?.transport?.nextPosition?.firstTimeSlotStart && !transport?.transport?.nextPosition?.lastTimeSlotEnd) {
      <sc-icon iconClass="fa-calendar"></sc-icon>
      <sc-content-spacer [half]="true"></sc-content-spacer>
      {{transport?.transport?.timing.planningDate | timestamp }}
      @if (transport?.transport?.timing?.timeSlotDelay) {
        (+{{transport?.transport?.timing?.timeSlotDelay}})
      }
    }
    @if (transport?.transport?.nextPosition?.firstTimeSlotStart && transport?.transport?.nextPosition?.lastTimeSlotEnd) {
      <sc-icon iconClass="fa-calendar"></sc-icon>
      <sc-content-spacer [half]="true"></sc-content-spacer>
      {{transport?.transport?.nextPosition.firstTimeSlotStart | timestamp:['optimizeToday'] }} -
      {{transport?.transport?.nextPosition.lastTimeSlotEnd | timestamp:['timeonly'] }}
      @if (transport?.transport?.timing.timeSlotDelay) {
        (+{{transport?.transport?.timing.timeSlotDelay}})
      }
    }
    <sc-content-spacer grow></sc-content-spacer>

    @if (transport.transport.masterdata.important) {
      <div class="status-icon">
        <sc-icon iconClass="fa-exclamation"></sc-icon>
      </div>
    }
    @if (transport.transport.masterdata.dangerousGoods) {
      <div class="status-icon">
        <sc-icon iconClass="fa-skull-crossbones"></sc-icon>
      </div>
    }
    @if (transport.transport.processing.pendingTaskState !== TransportTaskStatus.NONE) {
      <div class="status-icon">
        <app-task-state-icon [state]="transport.transport.processing.pendingTaskState"></app-task-state-icon>
      </div>
    }
    @if (transport.transport.masterdata.urgent) {
      <div class="status-icon">
        <sc-icon iconClass="fa-truck-fast"></sc-icon>
      </div>
    }
    @if (transport.transport.processing.inUmbrueckung) {
      <div class="status-icon">
        <sc-icon iconClass="fa-random"></sc-icon>
      </div>
    }
  </sc-flex>
  <sc-flex>
  </sc-flex>
</div>
